import { render, staticRenderFns } from "./deleteApplyWithholdGold.vue?vue&type=template&id=712e37d8"
import script from "./deleteApplyWithholdGold.vue?vue&type=script&lang=js"
export * from "./deleteApplyWithholdGold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports